import _ from 'lodash';
import Nested from 'nested-property';
import ValidationMixin from './react-validation-mixin';

ValidationMixin.handleFieldChange = function (field, onChange) {
  return (e) => {
    let value;
    const object = _.cloneDeep(this.state);
    if ((e != null ? e.target : undefined) != null && e.target.hasOwnProperty('value')) {
      ({ value } = e.target);
    } else if ((e != null ? e.target : undefined) != null && e.target.hasOwnProperty('checked')) {
      value = e.target.checked;
    } else {
      // hope that this is ok, string or date or number support...
      value = e;
    }
    Nested.set(object, field, value);
    if (object.view != null) {
      object.view.hasChanges = true;
    }
    const ev = _.clone(e);
    return this.setState(object, () => {
      if (typeof onChange === 'function') {
        onChange(ev, value);
      }
      return this.validate(field);
    });
  };
};

ValidationMixin.link = function (key) {
  key = `${key.charAt(0).toUpperCase() + key.substring(1)}`;
  return {
    value: this.props[`value${key}`],
    onChange: this.props[`on${key}Change`]
  };
};

ValidationMixin.getInitialState = function () {
  return (this.binders = {});
};

ValidationMixin.bind = function (field, onChange, key) {
  let errorText;
  if (!this.isValid(field)) {
    errorText = _.first(this.getValidationMessages(field));
  } else {
    // Bit of a hack as joi now uses commas rather than full stops to delimit objects.
    let fieldComma = field.replace('.', ',');
    if (!this.isValid(fieldComma)) {
      errorText = _.first(this.getValidationMessages(fieldComma));
    }
  }

  const aux = key != null ? `${key.charAt(0).toUpperCase() + key.substring(1)}` : '';
  if (!onChange && !key && this.binders[field]) {
    let c;
    const cachedBinder = (c = this.binders[field]);
    cachedBinder.errorText = errorText;
    cachedBinder.submitted = this.state.submitted;
    cachedBinder[`value${aux}`] = Nested.get(this.state, field);
    return cachedBinder;
  }

  const props = {
    [`on${aux}Change`]: this.handleFieldChange(field, onChange),
    [`value${aux}`]: Nested.get(this.state, field),
    errorText
  };
  props.submitted = this.state.submitted;

  if (!onChange && !key) {
    this.binders[field] = props;
  }
  return props;
};

ValidationMixin.multiBind = function (keys) {
  let props = {};
  keys.map((key) => {
    return (props = _.merge({}, props, this.bind(key, null, key)));
  });
  return props;
};

//one way
ValidationMixin.read = function (field) {
  return { value: Nested.get(this.state, field) };
};

export default ValidationMixin;

export const { handleFieldChange, link, getInitialState, bind, multiBind, read } = ValidationMixin;
